var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g2, _g3, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g4, _path71, _path72, _path73, _path74, _path75, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgSurvey = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 221,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.986 140.035c3.426-1.977 9-1.977 12.425 0 3.425 1.978 3.425 5.194 0 7.172-3.425 1.978-8.999 1.976-12.426 0-3.424-1.978-3.424-5.196.001-7.172Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.986 147.006c3.427 1.976 8.999 1.978 12.427 0 1.641-.946 2.495-2.18 2.564-3.424l.005.005.003-1.722-.366.315c-.402-.785-1.136-1.525-2.208-2.145-3.426-1.976-9-1.977-12.425 0-1.027.593-1.745 1.297-2.155 2.046l-.411-.163-.003 1.7.007-.004c.08 1.233.933 2.453 2.562 3.392Z",
    fill: "#501456"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.416 145.23c1.665-.962 2.519-2.215 2.565-3.476-.051-1.259-.905-2.508-2.567-3.466-3.425-1.976-8.999-1.978-12.425 0-1.665.961-2.519 2.214-2.567 3.475.051 1.258.907 2.507 2.567 3.465 3.427 1.979 9.001 1.979 12.427.002Z",
    fill: "#2E2E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.135 141.655c-.767-.442-.947-1.053-.402-1.368.543-.313 1.605-.211 2.37.232.766.442.944 1.055.401 1.368-.543.313-1.603.209-2.369-.232ZM213.803 144.156c-.766-.443-.945-1.055-.402-1.368.543-.314 1.605-.211 2.372.231.764.443.944 1.053.401 1.368-.544.313-1.607.21-2.371-.231ZM209.304 141.617c-.291-.169-.293-.441 0-.61l5.342-3.084c.293-.168.766-.168 1.059 0 .293.169.293.443 0 .61l-5.344 3.084c-.289.17-.764.17-1.057 0Z",
    fill: "#501456"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.504 141.887a.695.695 0 0 0 .224-.198c.024-.299-.224-.65-.713-.932-.766-.441-1.827-.545-2.371-.232a.693.693 0 0 0-.223.198c-.024.299.224.65.713.932.766.441 1.827.545 2.37.232ZM216.172 144.387a.682.682 0 0 0 .223-.198c.024-.299-.225-.651-.713-.932-.767-.443-1.827-.545-2.37-.232a.693.693 0 0 0-.223.198c-.026.298.224.65.713.932.764.441 1.827.545 2.37.232ZM210.365 141.618l5.344-3.084a.565.565 0 0 0 .129-.1c-.014-.099-.085-.196-.216-.272-.293-.169-.766-.169-1.057 0l-5.343 3.083a.531.531 0 0 0-.129.101c.013.099.085.196.216.27.289.171.764.171 1.056.002Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.193 36.828s4.233 8.814 14.569 8.508l.834 2.28a3.623 3.623 0 0 1-1.623 4.395c-2.547 1.45-6.873 2.731-12.319-.223l-1.46-14.96Z",
    fill: "url(#survey_svg__a)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.88 121.418s-.83.761-1.107 1.728c-.276.968-.552 1.935.553 2.142 1.107.208 2.144 1.105 2.835 2.073.691.967 2.329 1.265 4.079 1.312 1.418.04 1.452-.968 1.314-1.451-.138-.484-1.66-1.728-2.766-2.626-1.107-.899-2.557-3.179-2.557-3.179h-2.352v.001ZM18.763 129.186l-.732 1.787a3.283 3.283 0 0 0-.18 1.887c.207 1.028.56 2.574.912 3.236.552 1.036 2.763 1.23 3.594.891.831-.338.474-2.391 0-4.554-.218-.997-1.037-3.249-1.037-3.249h-2.557v.002Z",
    fill: "#00AF9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m18.782 129.612-.33-4.051h3.142l-.441 4.277c-.002 0-1.38.926-2.371-.226Z",
    fill: "url(#survey_svg__b)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m28.87 122.177-.385-5.124 3.584.33-.826 4.794c-.001 0-.442.606-2.373 0Z",
    fill: "url(#survey_svg__c)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.682 70.825s-.267 33.702-4.498 48.049c0 0-1.192.88-4.03-.501 0 0-1.912-28.294-2.794-31.526-.882-3.234-.485-12.904-.485-12.904l11.807-3.118Z",
    fill: "#2E2E2E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.425 75.492s-.85 30.536-1.071 33.291c-.22 2.756 1.767 17.162 1.767 17.162s1.762 1.27 3.747.145c0 0 3.867-22.397 4.58-27.018.713-4.62 4.287-25.013 4.287-25.013l-13.31 1.433Z",
    fill: "#2E2E2E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.925 37.489c.931-.696 3.907-2.38 5.409-2.631 1.808-.303 4.212.634 5.853.859 1.527 1.314 3.42 4.64 2.972 13.067-.558 10.467 1.032 21.833 1.071 28.56-1.666.317-7.404 2.357-9.108.354-.288-7.914.611-23.267-.392-30.614-.82-5.989-4.319-8.361-5.805-9.595Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.158 48.784c.45-8.428-1.445-11.753-2.973-13.067 2.845.386 4.427 5.089 4.92 7.481.782 3.772.68 37.654.68 37.654s-.403.071-1.083.195c-1.07.196-2.056-.68-2.06-1.846-.025-7.494.014-20.981.516-30.417Z",
    fill: "url(#survey_svg__d)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m25.403 27.447-1.679 8.748c-.12.634.203 1.266.787 1.543 1.086.516 2.932 1.1 4.772.346a1.658 1.658 0 0 0 1.032-1.69l-.557-5.657-4.355-3.29Z",
    fill: "url(#survey_svg__e)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.727 46.941c-.818-6.025-4.318-8.21-5.804-9.453-1.029.365-1.893 1.12-2.626 2.085-1.06 1.4-1.832 3.251-2.366 5.074-1.847 4.598-3.718 11.248-1.231 15.232.089 8.389.747 18.816 2.32 24.027 0 0 1.538.475 2.086-3.793 0 0 .22 5.012 4.392 3.81.993-.285 2.321-.605 3.768-.927.9-.2 1.532-1.074 1.495-2.064-.33-8.862-1.096-27.086-2.034-33.991Z",
    fill: "url(#survey_svg__f)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 61.959c-1.393-.373-7.008-4.56-9.165-6.195-.63-.477-1.512-.5-2.13-.01-.606.48-1.207 1.298-1.25 2.661a2.147 2.147 0 0 0 1.447 2.09l8.991 3.103s1.955 3.477 5.055 3.918c3.1.44 3.582-2.157 2.97-3.15-.718-1.17-4.186-1.953-5.919-2.417Z",
    fill: "url(#survey_svg__g)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.957 54.861a.262.262 0 0 1-.237-.15c-1.406-3.029.623-7.726.71-7.923a.26.26 0 0 1 .344-.135.262.262 0 0 1 .135.344c-.02.046-2.023 4.679-.715 7.492a.26.26 0 0 1-.237.373Z",
    fill: "url(#survey_svg__h)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.773 47.889a1.353 1.353 0 0 1 .276-1.348c1.435-1.619 5.565-6.404 6.142-8.549.7-2.602-.226-3.982-.526-5.31-.3-1.327.974-.812 1.303.432.328 1.245 1.4-.55 1.627-1.09.227-.542 1.175-3.403 2.33-3.695 1.152-.293 2.674 2.227.59 6.913 0 0-1.934 2.14-2.53 4.147-.713 2.398-2.974 7.576-4.34 10.322a1.863 1.863 0 0 1-2.516.831c-.883-.45-1.859-1.248-2.356-2.653Z",
    fill: "url(#survey_svg__i)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.668 24.825s.83 5.878-.243 8.419c-1.073 2.54-3.489 1.292-6.398-.626-1.453-.959-2.619-3.706-2.619-3.706s3.664-10.604 9.26-4.087Z",
    fill: "url(#survey_svg__j)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m19.512 22.738 1.071-.329a.595.595 0 0 0 .42-.617l-.084-1.028a1.353 1.353 0 0 1 1.937-1.328l.174.085a.597.597 0 0 0 .856-.519.596.596 0 0 1 .898-.497l.27.159a.595.595 0 0 0 .886-.399l.103-.524c.121-.6.959-.652 1.151-.071l.065.195a.596.596 0 0 0 1.055.154l.147-.21c.332-.476 1.083-.245 1.086.337v.123a.596.596 0 0 0 .913.502l.444-.278a.596.596 0 0 1 .894.656l-.051.2a.597.597 0 0 0 .803.702l.71-.291a.596.596 0 0 1 .771.793l-.703 1.59c-.12.273.044.517.232.75.04.05.085.24.085.24.19.534.073 1.132-.306 1.552 0 0-.183.311-.292.323-.453.055-1.013-.689-1.784.388-.815 1.14-3.068.776-5.75 1.277-.328.061-.534.267-.653.568-.354.032-.76.194-.878.722-.288 1.27.943 1.81.895 2.216-.306 2.58-.747.868-1.011.337-.27-.543-1.25-2.313-1.876-2.866-.28-.247-.698-.339-1.076-.365a.594.594 0 0 1-.508-.827l.317-.737-1.423-.743c-.957-.502-.826-1.922.212-2.24Z",
    fill: "url(#survey_svg__k)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.322 63.148c-.058-.045.543-3.381.771-4.639.047-.25.302-.4.544-.318l4.053 1.377c.19.064.308.258.278.458L35.2 64.93c0-.001-2.768-.092-4.878-1.782Z",
    fill: "#00AF9B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.915 173.732v2.682c.019 6.282 4.15 12.557 12.403 17.351 16.61 9.65 43.623 9.65 60.341 0 8.414-4.856 12.617-11.231 12.599-17.594v-2.681c.018 6.365-4.185 12.739-12.599 17.594-16.718 9.65-43.732 9.65-60.341 0-8.254-4.796-12.384-11.069-12.403-17.352Z",
    fill: "#C9C9EC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.915 173.732v2.682c.019 6.282 4.15 12.557 12.403 17.351 3.27 1.899 6.942 3.426 10.863 4.578v-2.68c-3.919-1.153-7.593-2.679-10.863-4.579-8.254-4.796-12.384-11.069-12.403-17.352Z",
    fill: "#C9C9EC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M81.18 195.661v2.68c5.74 1.687 12.007 2.572 18.305 2.654v-2.683c-6.296-.08-12.563-.965-18.305-2.651Z",
    fill: "#C9C9EC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.486 198.314v2.682c11.237.147 22.569-2.265 31.173-7.231.421-.244.831-.489 1.231-.739v-2.682c-.4.25-.81.497-1.231.739-8.604 4.966-19.936 7.377-31.173 7.231Z",
    fill: "#DDDEFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M131.891 190.344v2.682c4.464-2.794 7.615-6.04 9.45-9.468v-2.682c-1.837 3.428-4.988 6.673-9.45 9.468Z",
    fill: "#C9C9EC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M141.339 180.876v2.683c1.285-2.404 1.925-4.897 1.919-7.388v-2.681c.006 2.49-.632 4.981-1.919 7.386Z",
    fill: "#C9C9EC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M70.51 156.141c-16.718 9.648-16.802 25.292-.192 34.942 16.611 9.65 43.623 9.65 60.342 0 16.718-9.65 16.81-25.292.2-34.942-16.611-9.65-43.631-9.65-60.35 0Z",
    fill: "#F1F1F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2E2E2E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.076 168.325.041 5.194c.017 6.11 4.033 12.21 12.059 16.871 16.15 9.381 42.414 9.383 58.668 0 8.18-4.721 12.268-10.919 12.251-17.107l-.041-5.195c.017 6.189-4.069 12.387-12.249 17.108-16.256 9.383-42.52 9.383-58.67 0-8.024-4.663-12.042-10.763-12.059-16.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.076 168.324.041 5.195c.017 6.11 4.033 12.209 12.059 16.871 3.18 1.846 6.752 3.33 10.562 4.45l-.04-5.194c-3.811-1.12-7.383-2.604-10.563-4.45-8.024-4.664-12.042-10.763-12.059-16.872Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.697 189.646.041 5.194c5.58 1.641 11.676 2.5 17.798 2.58l-.04-5.194c-6.123-.08-12.218-.939-17.799-2.58ZM99.496 192.224l.04 5.194c10.924.143 21.943-2.2 30.309-7.03.408-.237.807-.475 1.197-.718l-.04-5.195c-.388.244-.786.482-1.195.719-8.369 4.83-19.386 7.173-30.31 7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131 184.477.039 5.194c4.342-2.718 7.404-5.873 9.189-9.205l-.041-5.195c-1.783 3.333-4.847 6.488-9.187 9.206ZM140.188 175.27l.041 5.194c1.252-2.337 1.873-4.76 1.866-7.184l-.041-5.194c.007 2.424-.616 4.849-1.866 7.184Z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.323 151.22c-16.256 9.383-16.34 24.593-.188 33.974 16.15 9.382 42.413 9.382 58.67 0 16.255-9.383 16.346-24.591.194-33.974-16.15-9.381-42.42-9.381-58.676 0Z",
    fill: "#2E2E2E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.637 167.276v2.683c.017 6.281 4.149 12.556 12.402 17.351 16.612 9.649 43.623 9.649 60.342 0 8.414-4.856 12.617-11.231 12.598-17.595v-2.682c.017 6.365-4.184 12.739-12.598 17.594-16.719 9.65-43.732 9.65-60.342 0-8.253-4.794-12.384-11.067-12.402-17.351Z",
    fill: "#C9C9EC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.637 167.276v2.682c.017 6.282 4.149 12.557 12.402 17.351 3.27 1.9 6.945 3.426 10.862 4.577v-2.681c-3.917-1.152-7.593-2.677-10.862-4.578-8.253-4.794-12.384-11.067-12.402-17.351ZM80.903 189.205v2.681c5.741 1.686 12.008 2.571 18.307 2.653v-2.681c-6.299-.081-12.566-.965-18.307-2.653Z",
    fill: "#C9C9EC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.208 191.859v2.68c11.236.146 22.567-2.264 31.173-7.23.42-.243.83-.488 1.229-.738v-2.683c-.4.251-.809.497-1.229.739-8.606 4.968-19.937 7.378-31.173 7.232Z",
    fill: "#DDDEFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M131.611 183.888v2.682c4.464-2.794 7.616-6.04 9.451-9.467v-2.681c-1.835 3.426-4.985 6.672-9.451 9.466Z",
    fill: "#C9C9EC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.061 174.42v2.681c1.285-2.403 1.925-4.895 1.918-7.388v-2.682c.009 2.493-.633 4.986-1.918 7.389Z",
    fill: "#C9C9EC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.23 149.685c-16.72 9.65-16.803 25.294-.192 34.942 16.611 9.65 43.623 9.65 60.342 0 16.718-9.65 16.81-25.292.2-34.942-16.611-9.648-43.63-9.648-60.35 0Z",
    fill: "#F1F1F9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M72.924 183.442c-7.4-4.299-11.472-10.065-11.463-16.234.007-6.209 4.14-12.011 11.638-16.337 15.1-8.715 39.593-8.715 54.599 0 7.399 4.299 11.47 10.064 11.461 16.231-.008 6.211-4.143 12.014-11.641 16.342-7.551 4.359-17.446 6.535-27.33 6.535-9.889 0-19.763-2.178-27.264-6.537Zm1.008-31.128c-6.958 4.017-10.794 9.306-10.803 14.895-.006 5.549 3.77 10.803 10.633 14.79 14.54 8.447 38.28 8.447 52.92 0 6.961-4.018 10.797-9.309 10.807-14.9.007-5.548-3.767-10.799-10.63-14.786-7.271-4.225-16.841-6.337-26.426-6.337-9.584.002-19.18 2.114-26.501 6.338Z",
    fill: "#2E2E2E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M146.336 82.69c25.847 14.917 25.847 39.104 0 54.022-25.847 14.917-67.75 14.917-93.598 0-25.847-14.919-25.847-39.105 0-54.022 25.847-14.92 67.751-14.92 93.598 0Z",
    fill: "url(#survey_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M146.335 82.69c-25.847-14.917-67.75-14.917-93.6 0-25.845 14.917-25.845 39.105 0 54.022 25.848 14.917 67.753 14.917 93.599 0 25.849-14.919 25.849-39.106.001-54.022Zm-.49 53.738c-25.576 14.761-67.04 14.761-92.617 0-25.575-14.761-25.575-38.697 0-53.457 25.576-14.763 67.042-14.763 92.617 0 25.575 14.762 25.575 38.696 0 53.457Z",
    fill: "url(#survey_svg__m)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M139.364 9.522c21.994 12.695 21.994 33.28 0 45.974-21.996 12.695-57.657 12.695-79.653 0-21.996-12.695-21.996-33.28 0-45.974 21.995-12.696 57.657-12.696 79.653 0Z",
    fill: "url(#survey_svg__n)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M139.365 9.522c-21.997-12.694-57.657-12.694-79.653 0-21.995 12.695-21.995 33.28 0 45.974 21.994 12.695 57.656 12.695 79.653 0 21.994-12.696 21.994-33.28 0-45.974Zm-.418 45.732c-21.764 12.562-57.052 12.562-78.818 0-21.767-12.561-21.767-32.928 0-45.492C81.894-2.8 117.18-2.8 138.947 9.762c21.763 12.562 21.763 32.929 0 45.492Z",
    fill: "url(#survey_svg__o)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M78.34 12.026v25.588c-4.407 1.769-8.612 3.787-12.543 6.058-9.726 5.612-16.8 12.173-21.213 19.163V37.248c4.413-6.998 11.487-13.559 21.213-19.17 3.931-2.272 8.136-4.29 12.542-6.052ZM127.059 139.913v-25.588c4.406-1.078 8.611-2.437 12.542-4.092 9.726-4.089 19.902-11.33 24.317-17.63v25.589c-4.413 6.307-14.589 13.549-24.315 17.637-3.933 1.655-8.138 3.015-12.544 4.084ZM153.131 33.2v16.135c-2.544-5.397-7.489-10.494-14.837-14.732a60.134 60.134 0 0 0-5.462-2.78V15.68a60.143 60.143 0 0 1 5.462 2.782c7.348 4.241 12.293 9.34 14.837 14.737Z",
    fill: "#FF0082"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146.775 66.744s6.937-2.696 8.742-10.428c2.62-11.224-10.492-12.528-15.632-19.523-5.138-6.994-13.908-22.654-28.703-17.213-17.924 6.59-30.181.354-33.651 31.382-2.93 26.197 34.446 40.69 34.446 40.69l34.798-24.908Z",
    fill: "url(#survey_svg__p)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M116.614 83.094c0 .283-1.094 27.828-2.601 34.888-8.942 2.728-20.786-9.344-22.008-11.978-1.226-2.635 9.624-32.963 10-36.067.376-3.106 14.609 13.157 14.609 13.157Z",
    fill: "url(#survey_svg__q)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M143.937 62.921s-1.609 5.055-5.257 14.657c-6.085 16.023-14.713 21.213-17.754 22.693-3.041 1.479-11.88 1.129-20.605-13.423-8.724-14.556 2.921-21.507 3.221-22.404.105-.326 1.592-3.364 3.434-7.087 4.191-8.475 14.748-11.685 22.854-6.807 6.447 3.879 11.042 7.95 14.107 12.371Z",
    fill: "url(#survey_svg__r)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.094 64.103s-16.37 16.939 0 40.463c16.371 23.523 17.483 41.416-2.554 57.252-20.04 15.835-57.227-14.856-47.928-48.687 9.297-33.83 20.857-30.323 16.267-54.74-4.365-23.231 18.04-43.66 37.186-32.07 19.146 11.586-2.971 37.782-2.971 37.782Z",
    fill: "url(#survey_svg__s)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M147.657 58.49s1.669 6.059-2.746 4.905c-4.409-1.152-10.739-9.972-19.122-6.883-8.387 3.093-14.087-3.892-16.167 5.719-2.081 9.612-5.416 11.374-8.652 14.066-3.237 2.693-1.868 12.739-5.903 3.351-4.033-9.388-7.228-12.992-.352-18.98 6.876-5.985 12.719-8.233 17.239-12.958 4.52-4.724 9.022-5.381 11.96-4.712 2.944.665 17.507 8.13 18.643 9.015 1.135.886 5.1 6.477 5.1 6.477Z",
    fill: "url(#survey_svg__t)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m183.096 24-159.607.472 38.264 146.729s6.805 17.879 40.213 17.879 37.075-17.879 37.075-17.879l44.055-147.2Z",
    fill: "url(#survey_svg__u)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M130.544 119.878a.734.734 0 0 0-.532.779l-.004 7.986c.024.335.938 1.019 1.296.888 12.794-4.696 22.355-10.045 30.67-15.862.492-.345.771-.921.729-1.52l.083-7.679c-.02-.28-.834-.897-1.217-.563-7.351 6.392-16.758 11.937-31.025 15.971Z",
    fill: "url(#survey_svg__v)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M131.216 120.305a.736.736 0 0 0-.533.779l-.003 7.986a.512.512 0 0 0 .679.446c10.088-3.515 18.474-7.419 25.633-11.744l1.173 2.339.564-3.411c1.353-.854 2.099-1.503 3.367-2.389.489-.342.758-.918.715-1.512l-.003-8.233a.341.341 0 0 0-.565-.232c-7.331 6.42-16.762 11.937-31.027 15.971Z",
    fill: "#00AF9B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M133.653 122.83a.256.256 0 0 1-.077-.503c.143-.033 14.519-4.24 26.908-13.459a.257.257 0 0 1 .358.053.254.254 0 0 1-.053.357c-12.471 9.282-26.954 13.513-27.097 13.547a.123.123 0 0 1-.039.005ZM133.869 125.879a.257.257 0 0 1-.267-.198.253.253 0 0 1 .19-.306c.143-.032 14.519-4.239 26.908-13.459a.257.257 0 0 1 .358.053.254.254 0 0 1-.053.357c-12.471 9.283-26.954 13.514-27.097 13.548a.167.167 0 0 1-.039.005Z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M183.071 213.759s.492 1.295.643 1.777c.096.296.002 1.123-.081 1.717a1.044 1.044 0 0 1-.719.847 2.561 2.561 0 0 1-2.056-.223l-5.699-3.283a.68.68 0 0 1-.282-.864l.126-.288a1.07 1.07 0 0 1 1.166-.618c1.253.223 3.575.581 4.37.314 1.11-.371 2.532.621 2.532.621Z",
    fill: "#2E2E2E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M183.276 209.48s-.017 3.899-.165 4.442c-.15.548-1.924.528-2.399-.643-.404-.994-.625-4.234-.625-4.234l3.189.435Z",
    fill: "url(#survey_svg__w)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M175.356 215.451s.604 1.394.795 1.916c.116.32.056 1.229-.009 1.884-.042.437-.33.81-.744.963a2.81 2.81 0 0 1-2.262-.144l-6.4-3.316a.75.75 0 0 1-.351-.936l.126-.318c.2-.505.71-.808 1.248-.737 1.381.184 3.94.461 4.798.133 1.195-.461 2.799.555 2.799.555Z",
    fill: "#2E2E2E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M175.144 211.969s.304 3.885.2 4.443c-.103.557-1.872.683-2.443-.447-.483-.959-.968-4.168-.968-4.168l3.211.172Z",
    fill: "url(#survey_svg__x)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M186.433 170.287s-3.046 15.484-2.405 19.522c1.215 7.659-.286 19.671-.286 19.671-1.373.853-2.806.848-3.937 0 0 0-1.775-25.53-4.951-30.949v-8.595l4.229-4.615 7.483-2.945c.482 1.263.124 6.416-.133 7.911Z",
    fill: "url(#survey_svg__y)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M165.646 168.701s.726 10.433 2.242 20.923c1.426 9.873 3.636 19.744 3.953 22.643.046.433.281.82.643 1.06.481.323 1.257.63 2.335.408a.961.961 0 0 0 .749-.847c.33-3.22.502-17.904.492-20.556-.012-2.994 2.559-20.643 2.559-20.643l-.838-7.17-12.135 4.182Z",
    fill: "url(#survey_svg__z)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m175.891 119.733.565 5.479a.956.956 0 0 0 .793.839 5.708 5.708 0 0 0 4.263-.948c.589-.404.848-1.144.674-1.837l-1.011-4.038-5.284.505Z",
    fill: "url(#survey_svg__A)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M173.097 110.814s-1.059 6.899-.365 8.724c.691 1.824 5.031 2.658 6.143 2.117 1.113-.543 4.391-4.303 4.566-5.96 1.009-9.606-4.956-9.796-10.344-4.881Z",
    fill: "url(#survey_svg__B)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M160.862 149.818c-3.131-2.357-7.28.184-7.303 4.093-.002.374.344.689.691.572a.504.504 0 0 0 .182-.109c.48-.437 1.147-1.913 2.247-2.138 1.298-.265 2.03.179 3.593-.604l.59-1.814Z",
    fill: "url(#survey_svg__C)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M165.491 139.232c-1.47-1.988-3.988-3.89-5.61-6.287-1.498-2.212-2.477-4.588-3.523-6.884-1.038-.184-3.231-.747-3.595-1.909-.387-1.236.912-2.368.58-3.566-.235-.842-1.411-.871-1.149-2.005 3.754 1.207 6.122 4.449 8.375 7.698.665.962 1.394 1.978 2.194 2.914 1.573 1.841 2.711 4.026 3.191 6.399.313 1.561.338 3.051-.463 3.64Z",
    fill: "url(#survey_svg__D)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M160.291 124.188c-.284-.336-.969-.957-1.321-.986-.138-.012-.159.072-.198.581-.087 1.102-1.704 3.186-1.706 4.355-.008 3.941 5.443 11.05 9.419 12.647 3.529 1.416 11.978-3.278 13.592-4.405 1.614-1.127 3.252-4.942-.33-6.29-3.582-1.348-10.521 3.821-11.562 3.764-2.23-.122-5.904-7.333-7.894-9.666Z",
    fill: "url(#survey_svg__E)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M175.729 126.015c-1.135 3.881-4.459 5.176-8.03 10.693-2.752 4.25-1.046 9.679-.751 16.747.291 6.985-2.05 10.63-1.444 15.774.083.709.761 1.359 3.514 2.391 2.753 1.031 15.317-1.651 17.43-4.89 2.113-3.239-2.082-10.08-1.759-12.41 1.432-10.305.567-26.977-2.014-29.214-.687-.595-.117-2.239-1.331-1.907-3.475.949-2.302.325-5.135.17-.877-.046-.322 2.105-.48 2.646Z",
    fill: "url(#survey_svg__F)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M161.882 148.709s-2.097-.21-2.628 1.799c-.532 2.009 0 2.67 0 2.67s11.752 2.611 15.102-.06c2.975-2.369 7.692-17.821 7.508-19.781-.183-1.959-2.695-5.266-5.635-2.817s-4.048 12.792-6.873 15.848c-1.517 1.644-7.474 2.341-7.474 2.341Z",
    fill: "url(#survey_svg__G)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M176.542 130.282c2.629-.041 4.491 2.849 5.147 5.265 1.055 3.901.665 7.353-.217 11.252-.388 1.72-.853 3.758-1.597 4.644-1.791 2.138-3.718-.577-4.135-.039-.691.892-.855.837-.347 1.117 1.3.716 3.675 2.472 5.552-.16 1.188-1.667 1.425-2.664 2.026-4.659 1.174-3.907 1.348-8.841.563-12.849-.461-2.361-2.688-7.483-5.914-5.501-.343.21-.698.366-1.078.93Z",
    fill: "#FF0082"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M183.624 136.196c2.326.202 4.919-.65 6.878.648 2.396 1.588 1.996 5.722 1.449 8.443-.606 3.013-1.401 8.699-5.802 7.417-1.931-.561-3.602-1.979-3.703-4.026-.162-3.287.49-6.578.926-9.81.199-1.481-.209-2.808 1.427-3.239.821-.216 2.349.06 3.047.482.618-.075 1.436.063 2.026.395 1.631.917 1.614 2.878.569 4.397",
    fill: "#FF0082"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M173.668 109.209c-.529 2.389.129 4.139 1.983 5.431 1.89 1.315 3.4 3.73 3.416 5.842.02 2.579-3.582 4.699-3.227 7.298.16 1.176.709 1.406 1.594 1.694.972.316 1.806.874 2.392 1.761 1.1 1.666 1.563 2.9 3.793 3.091 2.268.192 4.83-1.583 5.036-3.945.063-.717-.439-1.418-.267-2.119.194-.785 1.057-1.374 1.6-1.915 1.57-1.562 3.867-4.753 2.499-7.01-.495-.815-1.356-1.331-1.93-2.09-.625-.827-.904-1.644-1.08-2.665-.376-2.187-.274-4.352-2.182-5.814-.688-.526-1.272-.837-1.815-1.501a6.297 6.297 0 0 0-2.118-1.697c-1.386-.698-3.335-1.011-4.859-.926-2.033.114-4.622 1.059-6.04 2.538-1.39 1.45-1.364 3.468-.157 3.669.426.07 1.079-.262 1.205.184.278.987.828 1.601 1.771 2.401",
    fill: "#2E2E2E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M11.318 188.668c7.425-4.284 19.502-4.284 26.925.002 7.424 4.285 7.426 11.256.002 15.54-7.425 4.285-19.504 4.285-26.929-.002-7.42-4.284-7.423-11.256.002-15.54Z",
    fill: "#009983"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.316 203.776c7.425 4.285 19.502 4.287 26.929.002 3.558-2.055 5.407-4.727 5.555-7.424l.014.008.008-3.729-.793.683c-.87-1.702-2.462-3.307-4.786-4.648-7.423-4.284-19.5-4.285-26.925 0-2.225 1.285-3.781 2.81-4.673 4.433l-.886-.355-.008 3.684.015-.01c.174 2.674 2.021 5.319 5.55 7.356Z",
    fill: "url(#survey_svg__H)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M38.255 199.926c3.606-2.083 5.46-4.798 5.562-7.531-.109-2.728-1.965-5.434-5.564-7.511-7.422-4.283-19.502-4.285-26.925-.001-3.607 2.083-5.461 4.799-5.563 7.534.112 2.723 1.966 5.431 5.563 7.507 7.423 4.287 19.502 4.287 26.927.002Z",
    fill: "url(#survey_svg__I)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M36.682 188.935c-.06-.201-.252-.378-.543-.497a2.153 2.153 0 0 0-.993-.131 1.755 1.755 0 0 0-.715.215 1.025 1.025 0 0 0-.177.126c.004.013.004.025.007.037.339 1.137.25 2.24-.223 3.242-.41 1.237-1.39 2.349-2.884 3.21-2.534 1.464-6.288 2.073-10.3 1.678-.424-.043-.86.039-1.166.214-.07.04-.126.084-.18.131a.62.62 0 0 0 .237.344c.205.169.511.281.86.315 4.874.482 9.48-.284 12.631-2.103 1.66-.959 2.813-2.148 3.412-3.472.354-1.044.374-2.162.034-3.309ZM12.37 190.309a1.507 1.507 0 0 0-.468.406c-.073.654.467 1.428 1.54 2.049 1.66.959 3.96 1.185 5.139.504a1.51 1.51 0 0 0 .468-.407c.072-.653-.466-1.431-1.542-2.05-1.659-.959-3.957-1.181-5.137-.502ZM21.757 184.891a1.517 1.517 0 0 0-.469.407c-.071.654.467 1.428 1.543 2.049 1.658.958 3.96 1.183 5.138.502.203-.117.356-.255.468-.405.072-.655-.466-1.429-1.54-2.051-1.662-.954-3.96-1.181-5.14-.502Z",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M165.212 77.366c2.884-1.665 7.576-1.665 10.46 0 2.884 1.664 2.884 4.372.001 6.037-2.884 1.664-7.576 1.664-10.46 0-2.885-1.665-2.885-4.373-.001-6.037Z",
    fill: "#BB1900"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M165.211 83.234c2.884 1.665 7.576 1.665 10.461 0 1.383-.798 2.101-1.836 2.159-2.883l.005.005.004-1.45-.309.265c-.337-.662-.956-1.284-1.859-1.805-2.884-1.665-7.576-1.665-10.458 0-.865.498-1.469 1.09-1.815 1.722l-.344-.138-.003 1.432.005-.004c.065 1.038.783 2.065 2.154 2.856Z",
    fill: "url(#survey_svg__J)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M165.216 75.896c2.884-1.665 7.576-1.665 10.458 0 2.884 1.664 2.884 4.372.002 6.037-2.884 1.664-7.576 1.664-10.46 0-2.884-1.665-2.884-4.371 0-6.037Z",
    fill: "#FD6666"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M175.676 81.739c1.401-.809 2.121-1.864 2.16-2.926-.044-1.059-.762-2.11-2.162-2.917-2.884-1.665-7.576-1.665-10.458 0-1.401.808-2.121 1.863-2.162 2.927.044 1.059.762 2.11 2.16 2.917 2.886 1.663 7.578 1.663 10.462-.001Z",
    fill: "url(#survey_svg__K)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M170.52 78.498c1.144-.66 2.815-.94 4.584-.765a.606.606 0 0 1 .314.114c.075.062.103.135.081.208-.017.058-.063.109-.134.15a.731.731 0 0 1-.424.078c-1.456-.145-2.819.078-3.739.61-.919.53-1.304 1.317-1.054 2.156.028.09-.023.18-.134.243a.635.635 0 0 1-.259.077.765.765 0 0 1-.361-.046c-.105-.043-.175-.107-.197-.18-.305-1.022.178-1.985 1.323-2.645ZM167.312 77.793c.645.373.796.888.338 1.152-.458.264-1.351.177-1.995-.195-.645-.371-.797-.889-.339-1.153.457-.263 1.35-.175 1.996.196ZM170.959 75.69c.644.373.795.888.339 1.152-.458.264-1.352.177-1.995-.196-.645-.37-.795-.888-.339-1.152.456-.264 1.35-.177 1.995.196Z",
    fill: "#FD7070"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M170.519 78.498c-.619.357-1.043.803-1.256 1.3-.111.364-.111.749.005 1.144.022.073.092.138.198.18.105.043.233.06.361.046a.64.64 0 0 0 .26-.076.303.303 0 0 0 .061-.045 1.611 1.611 0 0 1 .06-1.125c.136-.478.499-.903 1.069-1.233.919-.53 2.281-.753 3.739-.608a.733.733 0 0 0 .424-.078.322.322 0 0 0 .059-.045.24.24 0 0 0-.08-.114.597.597 0 0 0-.313-.114c-1.772-.172-3.442.108-4.587.768ZM165.316 77.6a.585.585 0 0 0-.189.166c-.02.252.189.548.601.784.646.373 1.539.46 1.996.196a.582.582 0 0 0 .189-.167c.02-.251-.189-.548-.6-.786-.645-.37-1.539-.46-1.997-.194ZM168.962 75.494a.605.605 0 0 0-.189.167c-.021.252.189.548.601.787.643.372 1.539.459 1.995.195a.545.545 0 0 0 .189-.166c.021-.25-.189-.549-.601-.785-.643-.375-1.537-.461-1.995-.198Z",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.981 17.46c.143.076.239.2.286.374a.99.99 0 0 1 .044.308c0 .308-.11.645-.33 1.013-.206.352-.454.6-.749.748-.264.162-.499.184-.705.067-.19-.118-.286-.33-.286-.638 0-.116.012-.234.033-.353.042-.223.127-.449.253-.682.206-.352.441-.61.705-.77.295-.163.543-.185.75-.068ZM14.755 15.82c.022.086.033.184.033.297 0 .308-.103.638-.309.99-.19.352-.432.616-.726.792-.293.161-.543.183-.75.066-.204-.117-.308-.337-.308-.66 0-.104.01-.211.033-.32.044-.223.136-.455.276-.693.206-.366.454-.623.749-.77.292-.175.536-.204.726-.086.138.078.23.206.276.384ZM6.755 19.528c.293-.162.55-.184.77-.067a.582.582 0 0 1 .253.375c.022.092.032.194.032.308 0 .323-.095.66-.286 1.012-.22.353-.476.608-.77.77-.278.175-.52.204-.726.087-.206-.133-.308-.353-.308-.66 0-.117.012-.234.032-.353.05-.225.141-.451.276-.683.206-.349.45-.612.727-.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.352 24.127C.117 23.776 0 23.314 0 22.74v-.023c0-.924.301-1.892.902-2.903.543-.953 1.226-1.665 2.047-2.134l9.815-5.664 4.886-2.827c.63-.381 1.18-.499 1.65-.352.132.015.263.057.396.132.133.058.242.14.33.242l1.013.55a1.51 1.51 0 0 0-.682-.022c-.337.044-.69.175-1.056.396l-14.7 8.469c-.823.485-1.504 1.203-2.047 2.156-.538.906-.834 1.774-.89 2.607-.007.1-.013.2-.013.297v.022c0 .454.074.835.22 1.143.118.264.293.484.528.66L.99 24.677a.247.247 0 0 1-.089-.044 1.556 1.556 0 0 1-.55-.506ZM5.348 24.917l.505-.286 2.333 2.509-1.65-.924-1.188-1.299Z",
    fill: "#EA0080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.186 27.14-2.332-2.508-.506.285-.749.441c-.718.41-1.335.512-1.849.308a2.452 2.452 0 0 1-.197-.088.575.575 0 0 0-.155-.089 1.66 1.66 0 0 1-.528-.66c-.146-.308-.22-.69-.22-1.144v-.022c0-.097.004-.196.012-.296.056-.832.354-1.702.89-2.607.544-.953 1.227-1.672 2.047-2.157L19.3 10.135c.366-.22.719-.353 1.056-.397.235-.044.461-.037.682.022.089.044.198.096.33.153l.22.177c.41.353.617.925.617 1.716v.022c0 .924-.28 1.893-.836 2.904-.572.953-1.262 1.664-2.069 2.134l-8.912 5.17-2.202 5.104Z",
    fill: "#FF0082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.755 15.82a.584.584 0 0 0-.276-.384c-.19-.117-.432-.089-.726.087-.293.146-.543.403-.75.769-.14.238-.231.47-.275.693a1.59 1.59 0 0 0-.033.32c0 .323.102.543.309.66.206.117.454.095.749-.066.292-.177.536-.441.726-.792.207-.352.309-.682.309-.99 0-.111-.01-.21-.033-.297ZM10.981 17.46c-.206-.118-.454-.096-.749.066-.264.162-.499.417-.705.77-.126.23-.21.459-.253.682-.023.119-.033.236-.033.352 0 .308.096.52.286.638.206.118.441.096.705-.066.293-.146.543-.397.75-.749.219-.366.33-.705.33-1.013a.99.99 0 0 0-.045-.308.575.575 0 0 0-.286-.372ZM6.755 19.528c-.28.175-.521.44-.727.791a2.376 2.376 0 0 0-.276.683 1.896 1.896 0 0 0-.032.352c0 .308.102.527.308.66.206.118.448.089.727-.087.293-.161.55-.418.77-.769.19-.352.285-.69.285-1.013 0-.114-.01-.216-.032-.308a.576.576 0 0 0-.254-.374c-.22-.117-.475-.097-.77.065Z",
    fill: "#fff"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M139.398 216.176c-5.048 3.009-13.019 2.898-17.803-.247-4.785-3.147-4.573-8.137.475-11.146 5.048-3.009 13.019-2.9 17.805.247 4.784 3.145 4.571 8.137-.477 11.146Z",
    fill: "#FF0082"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M118.039 212.893c-.107 2.034 1.032 4.086 3.444 5.673 4.786 3.146 12.757 3.257 17.803.246 2.634-1.571 3.938-3.677 3.918-5.783h.012l.095-2.258c-.129 1.977-1.435 3.931-3.911 5.407-5.048 3.009-13.019 2.898-17.803-.247-2.39-1.573-3.532-3.603-3.449-5.618l-.109 2.58Zm.107-2.594c0-.015.004-.029.006-.042h-.004l-.002.042Zm25.18.092h-.01c0 .05.007.099.005.148l.005-.148Z",
    fill: "#EA0080"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M123.975 206.576c-1.852 1.104-2.857 2.552-3.022 4.03.038 1.48.918 2.956 2.675 4.111 3.721 2.446 9.922 2.533 13.848.193 1.852-1.105 2.857-2.553 3.02-4.032-.037-1.481-.918-2.956-2.675-4.11-3.721-2.446-9.92-2.533-13.846-.192Z",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M120.951 210.607c.166-1.477 1.168-2.925 3.022-4.03 3.926-2.34 10.125-2.255 13.847.193 1.757 1.155 2.637 2.629 2.674 4.11.184-1.655-.686-3.346-2.65-4.638-3.722-2.447-9.923-2.534-13.848-.192-2.072 1.235-3.087 2.9-3.045 4.557Z",
    fill: "#EA0080"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m134.998 213.545-4.122-2.594-.093-5.007c-.005-.318-.235-.461-.511-.321-.276.141-.494.51-.489.828l.099 5.247a.49.49 0 0 0 .043.201.32.32 0 0 0 .112.133l4.272 2.687c.199.125.515-.035.706-.359.189-.327.182-.691-.017-.815Z",
    fill: "url(#survey_svg__L)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__a",
    x1: 49.817,
    y1: 45.2,
    x2: 34.193,
    y2: 45.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__b",
    x1: 21.593,
    y1: 127.876,
    x2: 18.45,
    y2: 127.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__c",
    x1: 32.068,
    y1: 119.749,
    x2: 28.485,
    y2: 119.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__d",
    x1: 37.791,
    y1: 58.397,
    x2: 32.187,
    y2: 58.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__e",
    x1: 30.322,
    y1: 32.946,
    x2: 23.699,
    y2: 32.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__f",
    x1: 28.763,
    y1: 60.798,
    x2: 13.504,
    y2: 60.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__g",
    x1: 36.351,
    y1: 61.486,
    x2: 17.656,
    y2: 61.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__h",
    x1: 20.077,
    y1: 54.861,
    x2: 20.077,
    y2: 41.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__i",
    x1: 57.548,
    y1: 39.525,
    x2: 44.698,
    y2: 39.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__j",
    x1: 32.974,
    y1: 28.69,
    x2: 23.407,
    y2: 28.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79D53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__k",
    x1: 34.087,
    y1: 24.415,
    x2: 18.653,
    y2: 24.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__l",
    x1: 99.537,
    y1: 146.393,
    x2: 99.537,
    y2: 59.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__m",
    x1: 99.536,
    y1: 145.522,
    x2: 99.536,
    y2: 63.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__n",
    x1: 99.536,
    y1: 63.734,
    x2: 99.536,
    y2: -10.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__o",
    x1: 99.537,
    y1: 62.993,
    x2: 99.537,
    y2: -7.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#E51077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E51077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__p",
    x1: 149.173,
    y1: 8.544,
    x2: 30.695,
    y2: 153.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__q",
    x1: 73.517,
    y1: 148.523,
    x2: 113.21,
    y2: 85.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__r",
    x1: 135.503,
    y1: 131.606,
    x2: 110.6,
    y2: 30.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__s",
    x1: 65.099,
    y1: 94.539,
    x2: 126.13,
    y2: 94.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#810095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#9B0091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#C4008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#FD0082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__t",
    x1: 90.697,
    y1: 63.176,
    x2: 147.966,
    y2: 63.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__u",
    x1: 103.293,
    y1: 190.241,
    x2: 103.293,
    y2: -1.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#FF0082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#FF0082",
    stopOpacity: 0.043
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#FF0082",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__v",
    x1: 147.234,
    y1: 128.416,
    x2: 145.575,
    y2: 104.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__w",
    x1: 183.276,
    y1: 211.657,
    x2: 180.088,
    y2: 211.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__x",
    x1: 175.323,
    y1: 214.14,
    x2: 172.147,
    y2: 214.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__y",
    x1: 174.855,
    y1: 186.246,
    x2: 186.804,
    y2: 186.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__z",
    x1: 165.646,
    y1: 189.165,
    x2: 178.618,
    y2: 189.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__A",
    x1: 184.688,
    y1: 112.214,
    x2: 167.057,
    y2: 142.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#B54400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6813E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__B",
    x1: 183.277,
    y1: 133.249,
    x2: 172.847,
    y2: 97.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__C",
    x1: 160.863,
    y1: 151.709,
    x2: 152.32,
    y2: 151.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#B54400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6813E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__D",
    x1: 164.892,
    y1: 134.26,
    x2: 147.908,
    y2: 117.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#B54400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6813E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__E",
    x1: 157.067,
    y1: 132.125,
    x2: 181.891,
    y2: 132.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__F",
    x1: 165.405,
    y1: 147.502,
    x2: 187.047,
    y2: 147.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__G",
    x1: 159.018,
    y1: 141.988,
    x2: 181.869,
    y2: 141.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__H",
    x1: 31.037,
    y1: 184.508,
    x2: 17.761,
    y2: 207.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#169D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__I",
    x1: 31.44,
    y1: 180.953,
    x2: 18.193,
    y2: 203.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__J",
    x1: 172.891,
    y1: 75.753,
    x2: 167.733,
    y2: 84.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopColor: "#E51077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95B11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__K",
    x1: 173.047,
    y1: 74.373,
    x2: 167.901,
    y2: 83.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey_svg__L",
    x1: 134.276,
    y1: 215.008,
    x2: 129.019,
    y2: 205.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })))));
};
export { SvgSurvey as ReactComponent };
export default __webpack_public_path__ + "1347a965c16a84d915e95e4d2257fbdb.svg";